import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { useHeaderFlyoutStore, useHeaderLayoutStore } from '../../../shared';
export function useDesktopMenu() {
  const $ = _c(23);
  const pathname = usePathname();
  const [openMenu, setOpenMenuState] = useState(null);
  const [portalContainer, setPortalContainer] = useState(null);
  const isDesktopMenu = useHeaderLayoutStore(_temp);
  const setFlyoutOpen = useHeaderFlyoutStore(_temp2);
  let t0;
  if ($[0] !== isDesktopMenu || $[1] !== setFlyoutOpen) {
    t0 = function setOpenMenu(value) {
      if (value && !isDesktopMenu) {
        return;
      }
      setOpenMenuState(value);
      setFlyoutOpen("menu", Boolean(value));
    };
    $[0] = isDesktopMenu;
    $[1] = setFlyoutOpen;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setOpenMenu = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = element => {
      setPortalContainer(element?.closest(".header__main-section-sticky") ?? null);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setNavigationRoot = t1;
  let t2;
  let t3;
  if ($[4] !== isDesktopMenu || $[5] !== setFlyoutOpen) {
    t2 = () => {
      if (isDesktopMenu) {
        return;
      }
      setOpenMenuState(null);
      setFlyoutOpen("menu", false);
    };
    t3 = [isDesktopMenu, setFlyoutOpen];
    $[4] = isDesktopMenu;
    $[5] = setFlyoutOpen;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== setFlyoutOpen) {
    t4 = () => {
      setOpenMenuState(null);
      setFlyoutOpen("menu", false);
    };
    $[8] = setFlyoutOpen;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== pathname || $[11] !== setFlyoutOpen) {
    t5 = [pathname, setFlyoutOpen];
    $[10] = pathname;
    $[11] = setFlyoutOpen;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[13] !== setFlyoutOpen) {
    t6 = () => () => setFlyoutOpen("menu", false);
    t7 = [setFlyoutOpen];
    $[13] = setFlyoutOpen;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== setOpenMenu) {
    t8 = () => setOpenMenu(null);
    $[16] = setOpenMenu;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== openMenu || $[19] !== portalContainer || $[20] !== setOpenMenu || $[21] !== t8) {
    t9 = {
      closeMenu: t8,
      openMenu,
      portalContainer,
      setNavigationRoot,
      setOpenMenu
    };
    $[18] = openMenu;
    $[19] = portalContainer;
    $[20] = setOpenMenu;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp2(state_0) {
  return state_0.setFlyoutOpen;
}
function _temp(state) {
  return state.isDesktopMenu;
}